import { Box, Button, Link, SxStyleProp, Text } from 'theme-ui';

import { centeredContent, hidden } from 'utils/mixins';
import { FileInputChildrenType } from 'shared/FileInput';
import Icon, { IconTypes } from 'shared/Icon';
import { useTranslator } from '@picsart/rc/services/localization';

const styles = {
  p: 4,
  borderWidth: 1,
  borderRadius: 'default',
  borderStyle: 'dashed',
  width: '100%',
  height: '100%',
  ...centeredContent
};

const wrapStyles: SxStyleProp = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column'
};

const limitTextStyles: SxStyleProp = {
  my: 2,
  fontSize: 1,
  color: 'grey4',
  opacity: 0.7,
  textAlign: 'center'
};

const freeToEditTextStyles: SxStyleProp = {
  my: 2,
  fontSize: 1,
  color: 'grey4',
  textAlign: 'center'
};

export const UploadScene = ({
  handleInputChange,
  handleOpenPhotoSidebar,
  handleUploadClick,
  inputRef,
  handleOpenVideoSidebar,
  accept
}: FileInputChildrenType & {
  handleOpenPhotoSidebar: () => void;
  handleOpenVideoSidebar: () => void;
  handleUploadClick?: () => void;
}) => {
  const translator = useTranslator();
  return (
    <Box sx={{ borderColor: 'grey3', ...styles }}>
      <div sx={{ ...wrapStyles }}>
        <Button as="label" variant="primary" type="button" data-test="upload">
          <Icon name="upload-gen" sx={{ mr: 1 }} type={IconTypes.White} />
          {translator('Upload')}
          <input
            sx={hidden}
            type="file"
            ref={inputRef}
            onChange={handleInputChange}
            accept={accept}
            name="file"
            multiple={true}
            onClick={handleUploadClick}
          />
        </Button>
        <Text variant="body" sx={{ ...limitTextStyles }}>
          {translator('Maximum_500MB_per_file')}
        </Text>
        <Text variant="body" sx={{ ...freeToEditTextStyles }}>
          {translator('or use a')}
          <Link onClick={handleOpenPhotoSidebar} variant="bold" data-test="photo-link">
            {' '}
            {translator('Photo')}{' '}
          </Link>
          {translator('or a')}
          <Link onClick={handleOpenVideoSidebar} variant="bold" data-test="video-link">
            {' '}
            {translator('Video')}{' '}
          </Link>
          <br />
          {translator('from our library')}{' '}
        </Text>
      </div>
    </Box>
  );
};
